<template>
    <v-row style="max-width: 600px; margin: 0 auto;" >
        
        <v-col id="base" md="12" style="height: 100%;" class="my-0 py-0" >
            <!-- Back button -->
            <v-row justify="start" align="center" style="height:55px; background-color: #e6e6e6;" class="pt-0">
                <v-btn @click="$router.push({ name: 'menu'})" icon  :color="$store.state.colors.primary">
                    <v-icon x-large >mdi-chevron-left</v-icon>
                </v-btn>
            </v-row>

            <v-row class="RestoRegular mt-5 pl-6 mb-4" style="height:20px; font-size: 20px; color: #4D4D4D;">
                Errores de tarjeta con opción de seleccionar un método de pago diferente
            </v-row>
        </v-col>
    </v-row>
</template>


<script>
export default {
    data() {
        return {

        }
    },
    created() {

    },
    watch:{

    },
    methods: {

    }
}
</script>

<style scoped>
    .rounded-btn{
       border-radius:20px;
    }

    .hidscroll {
        overflow-y: scroll;
        overflow-x: hidden;
    }

    .active {
        color: white;
    }

</style>